<template>
    <portal to="modal" v-if="showPopup">
        <modal @close="showPopup = false">

            <template v-slot:header>E-Mail versenden</template>

            <input-text v-model="to" class="mb-4">
                Empfänger
                <template v-slot:helper>z.B. hello@example.com</template>
            </input-text>

            <input-text v-model="subject" class="mb-4">
                Betreff
            </input-text>

            <div class="mb-4">
                <label for="email"></label>
                <div ref="editor"
                     class="shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md" style="height: 200px">
                </div>
            </div>

            <div class="mb-4">
                <label for="attachment">Dateianhang (optional)</label>
                <input
                    id="attachment"
                    type="file"
                    @change="handleFileUpload"
                    class="block w-full mt-1"
                />
            </div>

            <loading v-show="loading"></loading>

            <div class="flex justify-end" v-show="!loading">
                <button-primary @click="send">
                    <i class="fa fa-envelope mr-2"></i> E-Mail versenden
                </button-primary>
                <button-secondary class="ml-2" @click="close">
                    <i></i> Nein Danke
                </button-secondary>
            </div>

        </modal>
    </portal>
</template>

<script>
import Modal from "./Modal";
import ButtonPrimary from "./UI/ButtonPrimary";
import InputText from "./UI/InputText";
import Loading from "./UI/Loading";
import ButtonSecondary from "./UI/ButtonSecondary.vue";
import Quill from 'quill';
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.snow.css";

export default {

    name: "Email",

    components: {
        ButtonSecondary,
        Loading,
        InputText,
        ButtonPrimary,
        Modal,
    },

    data: () => ({
        loading: false,
        showPopup: false,
        id: null,
        body: '',
        subject: '',
        to: '',
        attachment: null,
        quill: null,
    }),

    watch: {
        showPopup(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    if (this.$refs.editor) {
                        this.quill = new Quill(this.$refs.editor, {
                            theme: 'snow',
                        });

                        this.quill.on('text-change', () => {
                            this.body = this.quill.root.innerHTML;
                        });
                    } else {
                        console.error('Editor-Container nicht gefunden');
                    }
                });
            }
        },

        body(newValue) {
            if (this.quill && this.quill.root.innerHTML !== newValue) {
                this.quill.root.innerHTML = newValue;
            }
        }
    },

    methods: {
        handleFileUpload(event) {
            this.attachment = event.target.files[0];
        },
        open(id) {
            this.id = id;
            this.showPopup = true;
            this.load();
        },
        load() {
            this.loading = true;
            this.$http.get(`/admin/mail_messages/${this.id}`)
                .then(result => {
                    this.loading = false;
                    this.body = result.data.data.body;
                    this.subject = result.data.data.subject;
                    this.attachment = result.data.data.attachment;
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
        send() {
            this.loading = true;
            const formData = new FormData();
            formData.append('to', this.to);
            formData.append('subject', this.subject);
            formData.append('action', 'send');
            formData.append('body', this.body);

            if (this.attachment) {
                formData.append('attachment', this.attachment);
            }

            this.$http.post(`/admin/mail_messages/${this.id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(() => {
                this.loading = false;
                this.showPopup = false;
                this.$root.$emit('alert', 'E-Mail versendet.');
            }).catch((error) => {
                this.loading = false;
                this.$root.$emit('error', error);
            });
        },
        close() {
            this.showPopup = false;
        }
    }
}
</script>

<style scoped>

</style>
